"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaDataClient = void 0;
const url_search_params_1 = __importDefault(require("@ungap/url-search-params"));
const APIErrors_1 = require("./resources/APIErrors");
const APITasks_1 = require("./resources/APITasks");
const APIAbortController_1 = require("./APIAbortController");
const FSIServerClientInterface_1 = require("./FSIServerClientInterface");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const index_1 = require("./index");
const LogLevel_1 = require("./LogLevel");
const URLSearchParams = url_search_params_1.default;
const MetaDataNumberDefaults = {
    "directory": {
        "lastmodified": 0,
    },
    "file": {
        "height": 0,
        "importstatus": 0,
        "importtimestamp": 0,
        "lastmodified": 0,
        "levels": 0,
        "size": 0,
        "width": 0
    }
};
const MetaDataBooleanDefaults = {
    "directory": {},
    "file": {
        "alpha": false
    }
};
class MetaDataClient {
    constructor(classInit, taskController) {
        this.classInit = classInit;
        this.taskController = taskController;
        this.client = classInit.client;
        this.com = classInit.com;
        this.baseURL = this.client.getServerBaseQueryPath();
    }
    static GET_META_QUERY(data, cmd = "saveMetaData") {
        const q = new URLSearchParams();
        q.set("cmd", cmd);
        const emptyValues = (cmd.toLowerCase() !== "savemetadata");
        const rawData = data;
        const keys = Object.keys(data);
        const firstKey = keys[0];
        if (firstKey) {
            if (typeof (rawData[firstKey]) === "object") {
                for (const key of keys) {
                    if (typeof (rawData[key]) === "object") {
                        for (const nam of Object.keys(rawData[key])) {
                            if (emptyValues || typeof (rawData[key][nam]) === "string") {
                                const val = (emptyValues) ? "" : rawData[key][nam];
                                q.set(key + "." + nam, val);
                            }
                        }
                    }
                }
            }
            else {
                for (const key of keys) {
                    if (emptyValues || typeof (rawData[key]) === "string") {
                        const val = (emptyValues) ? "" : rawData[key];
                        q.set(key, val);
                    }
                }
            }
        }
        return q;
    }
    get(path, options = {}) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(options.abortController)) {
            return this.com.getAbortPromise();
        }
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_FILE_PATH(path);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.getMetaData, [path]);
        const q = new URLSearchParams("type=info");
        q.set("tpl", options.template || "interface_metadata.json");
        q.set("renderer", options.renderer || "noredirect");
        q.set("headers", options.headers || "webinterface");
        q.set("source", path);
        const url = this.baseURL + q.toString();
        return this.com.getJSON(url, { def: APIErrors_1.APIErrors.getMetaData, content: [path] }, undefined, options)
            .then(meta => {
            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
            if (typeof (meta) === "object") {
                if (typeof (meta.general) === "object") {
                    const type = (meta.general.size === undefined) ? "directory" : "file";
                    for (const o of Object.keys(MetaDataNumberDefaults[type])) {
                        if (meta.general[o] === undefined) {
                            meta.general[o] = MetaDataNumberDefaults[type][o];
                        }
                        else {
                            meta.general[o] = parseInt(meta.general[o], 10);
                        }
                    }
                    for (const o of Object.keys(MetaDataBooleanDefaults[type])) {
                        if (meta.general[o] === undefined) {
                            meta.general[o] = MetaDataBooleanDefaults[type][o];
                        }
                        else {
                            meta.general[o] = (meta.general[o] === "true");
                        }
                    }
                }
                return meta;
            }
            else {
                throw this.com.err.get(APIErrors_1.APIErrors.getMetaData, [path], APIErrors_1.APIErrors.invalidServerReply);
            }
        });
    }
    setByFunction(entry, cmd = "saveMetaData", fnMeta, options = {}) {
        const self = this;
        if (APIAbortController_1.APIAbortController.IS_ABORTED(options.abortController)) {
            return this.com.getAbortPromise();
        }
        return new Promise((resolve, reject) => {
            fnMeta(entry)
                .then(md => {
                APIAbortController_1.APIAbortController.THROW_IF_ABORTED(options.abortController);
                if (md !== null) {
                    const promise = self.set(entry.path, entry.type, md, cmd, options);
                    return resolve(promise);
                }
                else {
                    return resolve(FSIServerClientInterface_1.FSIServerClientInterface.GET_TRUE_PROMISE());
                }
            })
                .catch(err => {
                reject(new Error(err.message));
            });
        });
    }
    set(path, service, data, cmd = "saveMetaData", options = {}) {
        return this.setWithQuery(path, service, MetaDataClient.GET_META_QUERY(data, cmd), options);
    }
    setWithQuery(path, service, query, options = {}) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(options.abortController)) {
            return this.com.getAbortPromise();
        }
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_FILE_PATH(path);
        this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.setMetaData, [service, path, query.toString()]);
        const url = this.client.getServicePath(service) + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
        return this.com.postJSONBoolean(url, query, { def: APIErrors_1.APIErrors.changeMetaData, content: [path] }, null, options)
            .then(() => {
            return true;
        });
    }
    delete(path, service, data, options = {}) {
        return this.set(path, service, data, "deleteMetaData", options);
    }
    restore(path, service, data, options = {}) {
        return this.set(path, service, data, "restoreMetaData", options);
    }
}
exports.MetaDataClient = MetaDataClient;
